import InstagramReels from './InstagramReels';
import FeaturedArticles from '../Dashboard/FeaturedArticles/FeaturedArticles';
import FeatureSection from '../FeatureSection';
import './Sidebar.css';

// HunchChart moved up to the Hero block so it sits at the top of the
// page alongside the countdown — see Hero.tsx.

export default function Sidebar() {
  return (
    <aside className="page-side" aria-label="Election pulse">
      <div className="page-side__inner">
        <InstagramReels />
        <FeatureSection sectionKey="featured_articles" label="Featured pieces">
          <FeaturedArticles />
        </FeatureSection>
      </div>
    </aside>
  );
}
